import styled from 'styled-components';

export const AddtoFlowEventFloatWrapper = styled.div`
  position: absolute;
  right: 20px;
  top: 24px;
`;

export const PopHeader = styled.header`
  padding-bottom: 8px;
  font-size: 16px;
  height: 30px;
  font-weight: 600;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
`;

export const PopWrapper = styled.div`
  width: 450px;
  min-height: 200px;
  margin-right: 30px;
  .div-text {
    height: 40px;
    line-height: 40px;
  }

  .first-checkbox {
    display: flex;
    height: 32px;
    background: #f5f5f5;
    padding: 0 10px;
    align-items: center;
    border-top: 1px solid rgb(0 0 0 / 15%);
    color: rgba(0, 0, 0, 0.45);
  }

  .emp-ant-checkbox-group {
    max-height: 230px;
    overflow: auto;
    display: block;

    .emp-ant-checkbox-wrapper {
      margin: 0;
      .emp-ant-checkbox {
        align-self: baseline;
        margin-top: 4px;
        display: inline-block;
      }
    }
  }

  .flow-event-modal-checkbox {
    display: flex;
    width: 100%;
    padding: 0 10px;
    align-items: center;
    min-height: 32px;

    .checkbox-label {
      display: flex;
      > span:first-child {
        white-space: nowrap;
      }
    }
  }

  .div-apply {
    margin: 16px 10px;
    > span {
      margin-right: 8px;
    }

    display: flex;
    align-items: center;
    background-color: #fff;
  }
`;

export const PopFooter = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid #e8e8e8;

  .emp-ant-btn {
    margin-right: 8px;
  }
`;
